import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { refreshToken } from "../features/admin/adminSlice";

const useToken = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const accessToken = sessionStorage.getItem("token");
    const refreshTokenValue = sessionStorage.getItem("refreshToken");

    if (!accessToken || !refreshTokenValue) return;

    const decodeToken = (token) => {
      const base64Url = token.split('.')[1];
      const base64 = decodeURIComponent(
        atob(base64Url)
          .split('')
          .map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join('')
      );
      return JSON.parse(base64);
    };

    const { exp } = decodeToken(accessToken);
    const currentTime = Math.floor(Date.now() / 1000);
    const timeUntilExpiration = exp - currentTime;

    const handleSessionExpiry = () => {
      alert("세션이 만료되었습니다!");
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("refreshToken");
      navigate("/login"); 
    };

    if (timeUntilExpiration <= 0) {
      handleSessionExpiry();
      return;
    }

    if (timeUntilExpiration <= 300) {
      alert("세션이 곧 만료됩니다. 연장하시겠습니까?");
      dispatch(refreshToken());
    }

    const interval = setInterval(() => {
      const newTimeUntilExpiration = exp - Math.floor(Date.now() / 1000);

      if (newTimeUntilExpiration <= 0) {
        handleSessionExpiry();
        clearInterval(interval);
      } else if (newTimeUntilExpiration <= 300) {
        alert("세션이 곧 만료됩니다. 연장하시겠습니까?");
        dispatch(refreshToken());
      }
    }, 60000);

    return () => clearInterval(interval);
  }, [dispatch, navigate]);
};

export default useToken;
